import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { X } from "lucide-react";
import OrderForm from "./OrderForm";

export default function OrderModal({ step, onClose }) {
  const { t } = useLang();
  if (!step) return null;

  return (
    <div className="fixed inset-0 z-[70] bg-[#003087]/40 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose} data-testid="order-modal">
      <motion.div
        initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}
        onClick={(e) => e.stopPropagation()}
        className="w-full sm:max-w-lg bg-white border border-[#E2E8F0] rounded-t-3xl sm:rounded-3xl p-6 sm:p-8 max-h-[92vh] overflow-y-auto shadow-2xl"
      >
        <div className="flex items-start justify-between mb-6">
          <div>
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#00AEEF]">
              {step === "visure" ? t("m.step1tag") : t("m.step2tag")}
            </span>
            <h3 className="text-xl font-bold text-[#003087] mt-1.5">{step === "visure" ? t("m.title1") : t("m.title2")}</h3>
          </div>
          <button data-testid="order-modal-close" onClick={onClose} className="text-[#94A3B8] hover:text-[#003087] transition-colors duration-200 p-1" aria-label="chiudi">
            <X size={22} />
          </button>
        </div>
        <OrderForm defaultStep={step} onDone={onClose} testidPrefix="modal" />
      </motion.div>
    </div>
  );
}
